/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import DefaultPredicateComparisonOptions from 'predicates/models/data/default-predicate-comparison-options';
const BOOLEAN_COMPARISONS = {
  comparison: [{
    label: 'is true',
    value: 'true'
  }, {
    label: 'is false',
    value: 'false'
  }]
};
const CustomComparisonOptions = {
  custom: {
    'message.content': {
      string: {
        comparison: [{
          label: 'contains',
          value: 'contains'
        }]
      }
    },
    'message.url': {
      string: {
        comparison: [{
          label: 'is',
          value: 'eq'
        }, {
          label: 'contains',
          value: 'contains'
        }]
      }
    },
    'message.subject': {
      string: {
        comparison: [{
          label: 'contains',
          value: 'contains'
        }]
      }
    },
    'message.recipient': {
      string: {
        comparison: [{
          label: 'is',
          value: 'eq'
        }]
      }
    },
    'message.channel_is_android': {
      boolean: BOOLEAN_COMPARISONS
    },
    'message.channel_is_ios': {
      boolean: BOOLEAN_COMPARISONS
    },
    'message.channel_is_twitter': {
      boolean: BOOLEAN_COMPARISONS
    },
    'message.channel_is_facebook': {
      boolean: BOOLEAN_COMPARISONS
    }
  }
};
let mergedOptions = Object.assign({}, DefaultPredicateComparisonOptions, CustomComparisonOptions);
export default mergedOptions;